import { createContext } from 'react';
import { InitialValues } from '../constants';
export var AuthContext = createContext(InitialValues.AuthContext);
